import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from 'reducers';
import throttle from 'lodash/throttle';
import Core from 'managers/core';
import { loadState, saveState } from './persistState';
import isProduction from '../config';

// Creating store
let storeCreated = null;
const persistedState = loadState();

if (isProduction) {
    // In production adding only thunk middleware
    const middleware = applyMiddleware(thunk);

    storeCreated = createStore(rootReducer, persistedState, middleware);
} else {
    // In development mode beside thunk
    // DevTools are added
    const middleware = applyMiddleware(thunk);
    const enhancer = composeWithDevTools(middleware);

    storeCreated = createStore(rootReducer, persistedState, enhancer);
}

const store = storeCreated;

Core.setStore(store);

store.subscribe(
    throttle(() => {
        const { authentication } = store.getState();
        if (authentication && authentication.authenticated) {
            saveState({
                authentication: store.getState().authentication,
            });
        } else {
            saveState({});
        }
    }, 1000),
);

export default store;
